// import React, { useState } from "react";
// import QRCode from "react-qr-code";
// import Button from "src/components/Button";
// import { colors } from "src/styles";
// import styled from "styled-components";

// interface CleaningLogsQRcodeProps {
//   url: string;
//   size?: number;
//   onGenerateNewQrcode?: () => void;
//   onPrintQrcode?: () => void;
// }

// export const CleaningLogsQRcode = ({ url, size, onGenerateNewQrcode, onPrintQrcode }: CleaningLogsQRcodeProps) => {
//   const [isLoading] = useState<boolean>(false);

//   return (
//     <Content>
//       <ContentFrame>
//         <MainContainer>
//           <p>{url}</p>
//           <QRCode
//             size={size || 36}
//             style={{ height: "auto", maxWidth: "30%", width: "30%" }}
//             value={url}
//             viewBox={`0 0 36 36`}
//           />
//           <ButtonsContainer>
//             <Button
//               text="Generate New QR Code"
//               onClick={onGenerateNewQrcode}
//               disabled={isLoading}
//               additionalStyles={{
//                 color: colors.white.default,
//                 padding: "12px 24px",
//                 backgroundColor: colors.kleenway.green,
//               }}
//               variant="middle-primary"
//             />
//             <Button
//               text="Print QR code"
//               onClick={onPrintQrcode}
//               disabled={isLoading}
//               additionalStyles={{
//                 color: colors.white.default,
//                 padding: "12px 24px",
//                 backgroundColor: colors.kleenway.green,
//               }}
//               variant="middle-primary"
//             />
//           </ButtonsContainer>
//         </MainContainer>
//       </ContentFrame>
//     </Content>
//   );
// };

// const Content = styled.div`
//   box-sizing: content-box;
//   padding: 10px;
//   display: flex;
//   justify-content: center;
// `;

// const ContentFrame = styled.div`
//   width: 70%;
// `;

// const MainContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-around;
// `;

// const ButtonsContainer = styled.div`
//   width: auto;
//   height: auto;
//   display: flex;
//   flex-direction: column;
//   gap: 20px;
// `;

import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import Button from "src/components/Button";
import { colors, TopBar } from "src/styles";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { generatePrintTemplate } from "./template";
import { Container } from "src/components/ListScreen";
import BreadCrumbs from "src/components/BreadCrumbs";
import { WASHROOM_LOGS_BREADCRUMBS } from "../constants";
import { DBLocation, ID } from "src/types";
import { IMAGES } from "src/assets";
import { FirebaseDataService } from "src/services/Firebase/data";
import { useQueryParam } from "use-query-params";
// import { FirebaseDataService } from "src/services/Firebase/data";

const CleaningLogsQRcode = () => {
  const {
    locationId: locationId,
    clientCode: clientId,
    washroomId,
  } = useParams<{
    clientCode: string;
    locationId: string;
    washroomId: string;
  }>();

  const [washroomLabel] = useQueryParam<string>("washroomLabel");

  const navigate = useNavigate();

  const [location, setLocation] = useState<DBLocation>({} as DBLocation);

  const generateInitialUrl = () => {
    const initialTimestamp = Date.now();
    return (
      window.location.origin + `/${clientId}/${locationId}/${washroomId}/washroomLogs?timestamp=${initialTimestamp}`
    );
  };

  const getLocationData = async () => {
    if (locationId) {
      const { data: locationObject } = await FirebaseDataService.getLocationById(locationId as ID);

      if (locationObject) {
        setLocation(locationObject);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getLocationData();
  }, [locationId]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [qrCodeUrl, setQrCodeUrl] = useState<string>(() => generateInitialUrl());
  const [qrKey, setQrKey] = useState<number>(0);

  const handleGenerateNewQrcode = async () => {
    setIsLoading(true);

    try {
      const newTimestamp = Date.now();
      const newUrl =
        window.location.origin + `/${clientId}/${locationId}/${washroomId}/washroomLogs?timestamp=${newTimestamp}`;

      // await FirebaseDataService.updateQRCodeByWashroomId(locationId as ID, washroomId as ID, newTimestamp.toString());

      setQrCodeUrl(newUrl);
      setQrKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error generating new QR code:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrintQrcode = () => {
    const printContent = generatePrintTemplate(
      qrCodeUrl,
      IMAGES.KSI_MERGEDLOGO,
      colors.kleenway.green,
      location,
      washroomLabel || "",
      clientId || "",
    );
    const printWindow = window.open("", "_blank");

    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.focus();
    } else {
      console.error("Unable to open print window. Please check popup blocker settings.");
      alert("Unable to open print window. Please check your browser's popup blocker settings.");
    }
  };

  const onClickBreadcrumb = (route: ID | null) => {
    if (typeof route === "string") {
      let finalRoute = route;

      if (finalRoute.includes(":clientCode") && clientId) {
        finalRoute = finalRoute.replace(":clientCode", clientId);
      }
      if (finalRoute.includes(":locationId") && locationId) {
        finalRoute = finalRoute.replace(":locationId", locationId);
      }

      if (!finalRoute.includes(":")) {
        navigate(finalRoute);
      } else {
        console.warn("Cannot navigate: route contains unresolved placeholders:", finalRoute);
      }
    }
  };

  const breadcrumbs = WASHROOM_LOGS_BREADCRUMBS.map((crumb: { id: string; name: string }) => {
    const updatedCrumb = { ...crumb };
    if (crumb.id.includes(":clientCode") && clientId) {
      updatedCrumb.id = crumb.id.replace(":clientCode", clientId);
    }
    if (crumb.name === ":clientCode" && clientId) {
      updatedCrumb.name = clientId;
    }
    if (crumb.id.includes(":locationId") && locationId) {
      updatedCrumb.id = crumb.id.replace(":locationId", locationId);
    }
    if (crumb.name === ":locationId" && locationId) {
      updatedCrumb.name = locationId;
    }

    return updatedCrumb;
  });

  return (
    <Container>
      <TopBar>
        <BreadCrumbs folderStack={breadcrumbs} onClickItem={onClickBreadcrumb} />
      </TopBar>
      <Content>
        <ContentFrame>
          <MainContainer>
            <QRContainer>
              {isLoading ? (
                <LoaderContainer>
                  <Spinner animation="border" size="sm" />
                  <LoaderText>Generating new QR code...</LoaderText>
                </LoaderContainer>
              ) : (
                <QRCode
                  key={qrKey} // Force re-render when key changes
                  size={36}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={qrCodeUrl}
                  viewBox={`0 0 36 36`}
                />
              )}
            </QRContainer>

            <ButtonsContainer>
              <Button
                text={isLoading ? "Generating..." : "Generate New QR Code"}
                onClick={handleGenerateNewQrcode}
                disabled={isLoading}
                additionalStyles={{
                  color: colors.white.default,
                  padding: "12px 24px",
                  backgroundColor: isLoading ? colors.grey?.default || "#ccc" : colors.kleenway.green,
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                variant="middle-primary"
              />
              <Button
                text="Print QR code"
                onClick={handlePrintQrcode}
                disabled={isLoading}
                additionalStyles={{
                  color: colors.white.default,
                  padding: "12px 24px",
                  backgroundColor: isLoading ? colors.grey?.default || "#ccc" : colors.kleenway.green,
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                variant="middle-primary"
              />
            </ButtonsContainer>
          </MainContainer>
        </ContentFrame>
      </Content>
    </Container>
  );
};

// Styled components remain the same
const Content = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const ContentFrame = styled.div`
  width: 70%;
`;

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 20px;
`;

const QRContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
  width: 30%;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 10px;
`;

const LoaderText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
`;

const ButtonsContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default CleaningLogsQRcode;
